import { apiForPrivate } from '.';
import { TRUSTED_DRIVER_ENDPOINT } from '../../config/ap';

const apiCitations = apiForPrivate.injectEndpoints({
    overrideExisting: true,
    endpoints: build => ({
        getCitations: build.query({
            query: (params) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.CITATIONS}`,
                params,
            })
        }),
        getCitationDetail: build.query({
            query: (id) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.CITATIONS}/${id}`,
            })
        }),
    })
});

export const {
    useLazyGetCitationsQuery,
    useLazyGetCitationDetailQuery,
} = apiCitations;
